<template>
  <div class="content">
	<div id="scheduler_here" class="dhx_cal_container" style='width:100%; height:100%;'>
			<div class="dhx_cal_navline">
				<div class="dhx_cal_prev_button">&nbsp;</div>
				<div class="dhx_cal_next_button">&nbsp;</div>
				<div class="dhx_cal_today_button"></div>

				<div class="dhx_cal_date"></div>
				<div class="dhx_cal_tab" name="day_tab" style="right:204px;"></div>
				<div class="dhx_cal_tab" name="week_tab" style="right:140px;"></div>
				<div class="dhx_cal_tab" name="month_tab" style="right:76px;"></div>
			</div>
			 <div class="dhx_cal_header"></div>
		 	 <div class="dhx_cal_data"></div>

		
	
	  </div>

	
  </div>
</template>
<script>
import  'dhtmlx-scheduler'
import  "dhtmlx-scheduler/codebase/dhtmlxscheduler.js"
import  "dhtmlx-scheduler/codebase/sources/locale/locale_fr.js" 
import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_limit.js" 

import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_multiselect.js" 
import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_tooltip.js" 
import  "dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_quick_info.js"
import $ from 'jquery'
import {BACKEND_URL} from './GLOBALS'
import Vue from 'vue'
 
const moment = require('moment')
require('moment/locale/fr')

Vue.use(require('vue-moment'), {
    moment
}) 

  export default {
      name:'Planning',
    components: {
    },
    data() {
      return {
         liste_commercial:'',
		 listeClients:'',
		 liste_tache:'',
		 prevRoute: null
      }
    },
    mounted (){
      
        this.initSection()


    },
     created() {
          if (localStorage.getItem('reloaded')) {
        localStorage.removeItem('reloaded');
    } else {
        localStorage.setItem('reloaded', '1');
        location.reload();
    }
        $.ajaxSetup({
            data: {
              'sessionId': this.$store.getters.sessionId,
            },
          });
       var self= this
        var request = $.ajax({
            url: BACKEND_URL+"controller/agenda.php",
            async: false,
            type: "POST",
            data: {
            },
            dataType: "html",
            success: function(data) {
                var dataParsed = JSON.parse(data)                
                self.liste_commercial=dataParsed.listeCommercial
                self.listeClients=dataParsed.listeClients
				// if (self.$store.getters.restriction==1)
                //   self.liste_tache=dataParsed.listeTacheComplete.filter(data=>data.AUTEUR==self.$store.getters.login)
				// else
				// 	self.liste_tache=dataParsed.listeTacheComplete


				switch(true){
                  case (self.$store.getters.restriction == 1 && self.$store.getters.vendeur !== null):
                    self.liste_tache = dataParsed.listeTacheComplete.filter(data =>data.AUTEUR == self.$store.getters.login && data.VENDEUR == self.$store.getters.vendeur);
                    break;

                  case (self.$store.getters.restriction == 1 && self.$store.getters.vendeur == null):
                    self.liste_tache = dataParsed.listeTacheComplete.filter(data => data.AUTEUR == self.$store.getters.login);
                    break;

                  case (self.$store.getters.restriction != 1 && self.$store.getters.vendeur !== null):
                    self.liste_tache = dataParsed.listeTacheComplete.filter(data => data.VENDEUR == self.$store.getters.vendeur);
                    break; 

                  default:
                    self.liste_tache = dataParsed.listeTacheComplete;
                    break;
                  }	
 
            }
        })
    },
    methods:{
      
        exportPage(){
            scheduler.expand();
        },
		
        initSection(){


		var tabColorEvent=[];


                tabColorEvent[0]="#198754"; 
                tabColorEvent[1]="#0d6efd"; 
                tabColorEvent[2]="#ffc107"; 
                tabColorEvent[3]="#dc3545"; 
                tabColorEvent[4]="#6c757d";
     
         var liste_tache_final=[]
		 var i=0
           for (let key = 0; key <this.liste_tache.length; key++) {

						var DTE_DEBC = new Date(this.liste_tache[key]['DTE_DEBC'])
						var DTE_FINC = new Date(this.liste_tache[key]['DTE_FINC'])
					if (DTE_DEBC<=DTE_FINC ) {
						liste_tache_final[i]={}
						liste_tache_final[i]['start_date']= new Date(this.liste_tache[key]['DTE_DEBC'])
						liste_tache_final[i]['end_date']= new Date(this.liste_tache[key]['DTE_FINC'])
						liste_tache_final[i]['text']=this.liste_tache[key]['VENDEUR'] + "<br>" + this.liste_tache[key]['NUM_ACTION'] + ' - ' + this.liste_tache[key]['OBJET']
						liste_tache_final[i]['OBJET']=this.liste_tache[key]['OBJET']
						liste_tache_final[i]['priorite']=this.liste_tache[key]['PRIORITE']
						/*
						if (liste_tache_final[i]['priorite']=='0') {
							liste_tache_final[i]['color']=tabColorEvent[0];
						}
						else if( liste_tache_final[i]['priorite']=='1') {
							liste_tache_final[i]['color']=tabColorEvent[1];
						}
						else if( liste_tache_final[i]['priorite']== '2' ){
							liste_tache_final[i]['color']=tabColorEvent[2];
						}
						else if( liste_tache_final[i]['priorite']=='3') {
							liste_tache_final[i]['color']=tabColorEvent[3];
						}
						else if( liste_tache_final[i]['priorite']=='9') {
							liste_tache_final[i]['color']=tabColorEvent[4];
						}*/
						liste_tache_final[i]['color']=tabColorEvent[key % 4]
						liste_tache_final[i]['id']=this.liste_tache[key]['NUM_ACTION']
						liste_tache_final[i]['VENDEUR']= this.liste_tache[key]['VENDEUR']
						liste_tache_final[i]['nom_cli']= this.liste_tache[key]['NOM_CLI']
						i++
						}
						
				}
				console.log(liste_tache_final.length)
			scheduler.xy.min_event_height = 65;
        scheduler.init("scheduler_here");
        scheduler.parse(liste_tache_final);
			scheduler.locale.labels.timeline_tab ="Timeline";
			scheduler.config.multi_day = true;
			scheduler.config.multisection = true;
			scheduler.config.details_on_dblclick=true;
			scheduler.config.details_on_create=true;
			scheduler.config.quick_info_detached = true;
			scheduler.locale.labels.timeline_tab = "Semaine";
			scheduler.locale.labels.month_timeline_tab = "Mois";
			scheduler.locale.labels.unit_tab = "Unit";
			scheduler.locale.labels.section_custom = "Section";
            scheduler.config.start_on_monday = true;
			

			
            var sectionsCollab=[];
			var sectionsPresta=[];
			let index = -1;
			var listeindex=[];
			var sections=[];
            var section_id="key"
		

			
			
			
	
            for (var item in this.liste_commercial) {
					var row={key : this.liste_commercial[item].VENDEUR, label : this.liste_commercial[item].NOM};
					sections.push(row);
				}
	         scheduler.templates.event_text = function(start, end, event){
                    return event.text				
                    }

                    // quick_info_content - le contenu du formulaire d'édition contextuel
			scheduler.templates.quick_info_content = function(start, end, ev){ 
								return ev.nom_cli || ev.text;
							};



                         //quick_info_title - le titre du formulaire d'édition pop-up
			scheduler.templates.quick_info_title = function(start, end, ev){ 
							return ev.nom_cli.substr(0,50); 
						};


						//tooltip_text - le texte des info-bulles
			scheduler.templates.tooltip_text = function(start,end,ev){
						return "<b>Event:</b> "+ ev.text +'    '+ ev.nom_cli +"<br/><b>Start date:</b> " + 
						scheduler.templates.tooltip_date_format(start)+ 
						"<br/><b>End date:</b> "+scheduler.templates.tooltip_date_format(end);
					};

	     	scheduler.attachEvent("onTemplatesReady", function(){
                    scheduler.templates.event_text= function(start,end,event){
						return "<b>" + event.text +' '+ "</b><br><i>" + event.nom_cli + "</i>";
					}
				}); 
			scheduler.locale.labels.VENDEUR = "Commercial";
			scheduler.config.lightbox.sections=[
				{name:"Client", height:20, map_to:"nom_cli", type:"textarea",focus:true},
				{name:"Objet Action ", height:20, map_to:"text", type:"textarea" },
				{name:"Commercial", height:50,  type:"select" ,options:sections, map_to:"VENDEUR"},
				{name:"time", height:92,type:"time", map_to:"auto"}
			];
              

           
			scheduler.attachEvent("onEventSave", function(id,ev){
				
				var new_date_start = moment(ev.start_date, "llll").format("YYYY-MM-DD HH:mm:ss");
				var new_date_end = moment(ev.end_date, "llll").format("YYYY-MM-DD HH:mm:ss");
				var currentTime = new Date();
				var original=scheduler.getEvent(id);
				$.ajax({
					url : BACKEND_URL+"controller/agenda.php",
					type : "POST",
					async: false,
					data: {
						   'updatelightBox': 1,
						   'objet':ev.text,
						   'numAct':id,
					       'cde_profil':ev.VENDEUR,
						   'dte_deb':new_date_start,
						   'dte_fin':new_date_end
					},
					dataType : "html",
					success : function(data) {
					console.log('update fini');
					}
				});
				 return true;
			});




			scheduler.attachEvent("onEventDeleted", function(id,ev){
				var original=scheduler.getEvent(id);
				$.ajax({
					url : BACKEND_URL+"controller/agenda.php",
					type : "POST",
					async: false,
					data: {
						'deleteLightBox':1,
						'numAct':id,
					      
					},
					dataType : "html",
					success : function(data) {
					}
				});
				 return true;
             });



		 scheduler.attachEvent("onDragEnd", function(id, mode, e){
				 var ev = scheduler.getEvent(id); 
				var new_date_start = moment(ev.start_date, "llll").format("YYYY-MM-DD HH:mm:ss");
				var new_date_end = moment(ev.end_date, "llll").format("YYYY-MM-DD HH:mm:ss");
			
				$.ajax({
					url : BACKEND_URL+"controller/agenda.php",
					type : "POST",
					async: false,
					data: {
						   'updatelightBox': 1,
						   'objet':ev.text,
						   'numAct':ev.id,
					       'cde_profil':ev.VENDEUR,
						   'dte_deb':new_date_start.replace(" ", "T"),
						   'dte_fin':new_date_end.replace(" ", "T") 
					},
					dataType : "html",
					success : function(data) {
					}
				});
				 return true;
			 
			 
			 });


		},
          loadJs(url, callback) {
          	$.ajax({

		              url: url,
		              dataType: 'script',
		              success: callback,
		              async: true,
					success : function(data) {
						var s = document.createElement("script");
						s.type = "text/javascript";
						s.src = "http://somedomain.com/somescript";
						$("head").append(s);
					}
				});
          }
    }
  }
  </script>
<style>
@import "~dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css"
</style>
